module.exports = __webpack_public_path__ + "img/486.55032f3f.jpg";